import React, { useEffect, useState } from "react";

const FaqV1 = () => {
  const [registrationFaqs, setRegistrationFaqs] = useState([]);
  const [speakersFaqs, setSpeakersFaqs] = useState([]);
  const [abstractFaqs, setAbstractFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFaqs = async (type, setter) => {
    try {
      const res = await fetch(`https://eventscons.com/eventbackendnew/api/allfaqsregistration?&type=${type}`);
      const json = await res.json();
      if (res.ok) {
        setter(json.faqs || []);
      } else {
        console.error(`Failed to fetch ${type} FAQs:`, json);
        setter([]);
      }
    } catch (err) {
      console.error(`Error fetching ${type} FAQs:`, err);
      setter([]);
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchFaqs("registration", setRegistrationFaqs),
      fetchFaqs("speaker", setSpeakersFaqs),
      fetchFaqs("abstract", setAbstractFaqs),
    ]).finally(() => setLoading(false));
  }, []);

  const renderAccordion = (faqs, parentId) => (
    <ul className="accordion-box" id={parentId}>
      {faqs.map((faq, index) => {
        const collapseId = `${parentId}_collapse_${index}`;
        return (
          <li className="blocks" key={faq.id}>
            <span
              className="acc-btn"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#${collapseId}`}
              aria-expanded="false"
              aria-controls={collapseId}
            >
              {faq.question}
            </span>
            <div
              id={collapseId}
              className={`acc-content accordion-collapse collapse`}
              data-bs-parent={`#${parentId}`}
            >
              <div className="content">
                <div className="text">{faq.answer}</div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading FAQs...</p>;
  }

  return (
    <section className="faq-section">

      {/* Registration FAQs */}
      <div className="auto-container">
        <div className="sec-title">
          <span className="title">FAQS</span>
          <h2>Registration</h2>
        </div>
        <div className="row clearfix">
          <div className="content-column col-lg-12 col-md-12 col-sm-12">
            <div className="inner-column">
              {renderAccordion(registrationFaqs, "faqAccordion_registration")}
            </div>
          </div>
        </div>
      </div>

      {/* Speakers FAQs */}
      <div className="auto-container">
        <div className="sec-title">
          <span className="title">FAQS</span>
          <h2>Speakers</h2>
        </div>
        <div className="row clearfix">
          <div className="content-column col-lg-12 col-md-12 col-sm-12">
            <div className="inner-column">
              {renderAccordion(speakersFaqs, "faqAccordion_speakers")}
            </div>
          </div>
        </div>
      </div>

      {/* Abstract FAQs */}
      <div className="auto-container">
        <div className="sec-title">
          <span className="title">FAQS</span>
          <h2>Abstract</h2>
        </div>
        <div className="row clearfix">
          <div className="content-column col-lg-12 col-md-12 col-sm-12">
            <div className="inner-column">
              {renderAccordion(abstractFaqs, "faqAccordion_abstract")}
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default FaqV1;